import React, { useEffect, useState } from 'react';
import axios from "axios";
import LocalStorageService from '../libs/LocalStorageService';
import ContractsTable from '../components/ContractsTable';
import CustomEmpty from "../components/CustomEmpty"
import ErrorComponent from '../components/ErrorComponent';

const token = LocalStorageService.getAccessToken();

const config = {
  headers: { Authorization: `Bearer ${token}` }
};

const Contracts = (props) => {
  const URL = "https://becomedigital-api.azurewebsites.net/api/v1";

  const [data, setData] = useState();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const getData = () => {
      axios
        .get(URL + "/contracts", config)
        .then((result) => {
          if (result.status === 200) {
            setData(result.data);
            setHasError(false);
          } else {
            setHasError(true);
          }
        })
        .catch((e) => {
          console.log(e);
          setHasError(true);
        });
    }

    getData();
  }, []);

  return (
    <main>
      {hasError ? <ErrorComponent /> : data ?
        <ContractsTable data={data} />
        :
        <div className="columns is-multiline mt-3 notification is-white">
          <div className="column is-full">
            <CustomEmpty />
          </div>
        </div>}
    </main>
  );
}

export default Contracts;
